import React, { Component } from 'react';
import { Row, Col, Table, Pagination } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";
import Switch from "react-switch";
import { toast } from 'react-toastify';

import ModalReports from '../../../components/Reportes/ModalReports';

import { CantEstudiantesDeuda, EstudiantesDeuda, EstudiantesDeudaInd, EstudiantesDeudaDat, FixDeuda, EstDisponibles, EliminarDec, CheckStatusDelT } from "../../../funciones/CobranzasFunction";
import { ConsultMetodos, ConsultCambio } from '../../../funciones/AdministracionFunction';
import { ConsultaNumCuenta } from "../../../funciones/EstCuentaFunction";

import EstDeudasTable from "./EstDeudasTable";
import AlumnosMorosos from '../../../components/Reportes/AlumnosMorosos';

let minResult = 10;
let limite = 0;
let UserState = "";

class EstDeudas extends Component {
    state = {
        estDeudores: [],
        estDeudoresNI: [],
        preloaderI: {
            icon: "fa fa-search",
            text: "Presiona el botón Iniciar Búsqueda para comenzar"
        },
        preloaderII: {
            icon: "fa fa-arrow-right",
            text: "Presiona el botón para comenzar"
        },
        cantRegistros: { value: 15, label: '- Mostrar en Páginas -' },
        pag: 1,
        paginas: 0,
        pagSelect: { value: 1, label: '- 1 -' },
        icon: "",
        icon2: "",
        string: "",
        control: false,
        control2: false,

        metodos: [],
        cambio: "",
        cuentas: [],
        nuCuenta:"",
        openWR: false,
        preloader2: "",
        preloaderPag: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Páginas</React.Fragment>,
        disabledBusq: false,
        regulares: true,
        disabled: true,
        btnBusq: {
            text: "Iniciar Búsqueda",
            icon: "fa fa-search",
            disabled: false
        },
        visibleSwitch: true,
        estDe:[],
        btnFix: {
            text: "Reparar",
            icon: "fa fa-cog"
        },
        btn2Fix: {
            text: "Reparar",
            icon: "fa fa-cog"
        },
        estCent: "",
        status: "",
    }

    componentDidMount = () => {
        ConsultMetodos ((resp) => {
            this.setState({
                metodos: resp
            })
        })
        ConsultCambio ((resp) => {
            this.setState({
                cambio: resp
            })
        })
        ConsultaNumCuenta ((resp) => {
            this.setState({
                nuCuenta: resp[0],
                cuentas: resp[1]
            })
        })
        CheckStatusDelT ((resp) => {
            UserState = resp
            this.setState({ status: resp })
        })
    }

    consultaEst = (limt, respuesta) => {
        if (this.state.disabledBusq === true) return null;
        EstudiantesDeudaDat (limt, (resp) => {

            let limit = limt + 1;
            respuesta(limit)

            if (resp[1][0] !== undefined){
                
                if (resp[1][0].MatInscritas === 0) {
                    let contenido = this.state.estDeudores
                    contenido.push(resp[1][0])

                    this.setState({
                        estDeudores: contenido,
                    }, () => {
                        if (resp[0].length > 0){
                            this.consultaEst(limit, (resp) => {
                                limite = resp;
                            })
                        }
                    })
                }else{
                    let contenido = this.state.estDeudoresNI
                    contenido.push(resp[1][0])

                    let contEst = this.state.estDe

                    contEst.push(resp[0][0].id_est)

                    this.setState({
                        estDe: contEst,
                        estDeudoresNI: contenido
                    }, () => {
                        if (resp[0].length > 0){
                            this.consultaEst(limit, (resp) => {
                                limite = resp;
                            })
                        }
                    })
                }

                
            }else{
                if (resp[0].length > 0){
                    this.consultaEst(limit, (resp) => {
                        limite = resp;
                    })
                }else{
                    /* console.log(this.state.estDe); */

                    this.setState({
                        preloaderI: {
                            icon: "",
                            text: "Ha finalizado la búsqueda"
                        },
                        preloaderII: {
                            icon: "fa fa-arrow-right",
                            text: "Presiona el botón para comenzar"
                        },
                        disabled: false,
                        btnBusq: {
                            text: "Iniciar Búsqueda",
                            icon: "fa fa-search",
                            disabled: false
                        }
                    }, () => {
                        if (this.state.regulares === false) {
                            toast.info(`Se encontraron ${this.state.estDeudores.length} estudiantes con deuda`,{autoClose: 4000});
                        }else{
                            toast.info(`Se encontraron ${this.state.estDeudoresNI.length} estudiantes con deuda`,{autoClose: 4000});
                        }
                    })
                }
            }
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: e.target.value
        })
    }

    updLista = () => {
        if (this.state.string === "") return null;        
        this.setState ({
            icon2: "fa fa-spinner fa-spin"
        }, () => {
            EstudiantesDeudaInd (this.state.string, (resp) => {
                let prel = { icon: "", text: "" };
                if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                this.setState({
                    estDeudores: resp,
                    icon2: "",
                    preloaderI: prel,
                    disabledBusq: true,
                    regulares: false,
                    preloaderI: {
                        icon: "",
                        text: "Ha finalizado la búsqueda"
                    },
                    preloaderII: {
                        icon: "fa fa-arrow-right",
                        text: "Presiona el botón para comenzar"
                    },
                    disabled: false,
                    btnBusq: {
                        text: "Iniciar Búsqueda",
                        icon: "fa fa-search",
                        disabled: false
                    },
                    visibleSwitch: false
                })
            })
        })
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            limite = 0;
            /* if (this.state.disabled === true){
                toast.error("Espera que termine de cargar el listado",{autoClose: 4000});
            }else{
                
                if (this.state.string === ""){
                    
                    this.setState({
                        disabled: true,
                        disabledBusq: false,
                        estDeudores: [],
                        preloaderI: {
                            icon: "fa fa-spinner fa-spin",
                            text: "Buscando estudiantes, espera"
                        },
                        estDeudores: [],
                        estDeudoresNI: []
                    }, () => {
                        this.consultaEst(limite, (resp) => {
                            limite = resp;
                        })
                        toast.info("Se están buscando los estudiantes con deuda, esta función puede tardar varios minutos, espere por favor",{autoClose: 8000});    
                    })
                }else{ */
                    if (this.state.string === "") return null;
                    
                    this.setState ({
                        icon2: "fa fa-spinner fa-spin"
                    }, () => {
                        EstudiantesDeudaInd (this.state.string, (resp) => {
                            let prel = { icon: "", text: "" };
                            if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };
        
                            this.setState({
                                estDeudores: resp,
                                icon2: "",
                                preloaderI: prel,
                                disabledBusq: true,
                                regulares: false,
                                preloaderI: {
                                    icon: "",
                                    text: "Ha finalizado la búsqueda"
                                },
                                preloaderII: {
                                    icon: "fa fa-arrow-right",
                                    text: "Presiona el botón para comenzar"
                                },
                                disabled: false,
                                btnBusq: {
                                    text: "Iniciar Búsqueda",
                                    icon: "fa fa-search",
                                    disabled: false
                                },
                                visibleSwitch: false
                            })
                        })
                    })
                /* }
            } */
        }
    }

    busquedaMoroso = () => {
        if (this.state.btnBusq.disabled === true) return null;

        this.setState({
            string: "",
            btnBusq: {
                text: "Buscando",
                icon: "fa fa-spinner fa-spin",
                disabled: true
            },
            preloaderI: {
                icon: "fa fa-spinner fa-spin",
                text: "Buscando estudiantes, espera"
            },
            preloaderII: {
                icon: "fa fa-spinner fa-spin",
                text: "Buscando, espera"
            },
            preloaderPag: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Páginas</React.Fragment>,
            disabled: true,
            estDeudores: [],
            estDeudoresNI: [],
            disabledBusq: false,
            regulares: true,
            visibleSwitch: true
        }, () => {
            limite = 0;
            this.consultaEst(limite, (resp) => {
                limite = resp;
            })
            toast.info("Se están buscando los estudiantes con deuda, esta función puede tardar varios minutos, espere por favor",{autoClose: 8000});
        }) 
    }

    contenido = () => {
        let { estDeudores, estDeudoresNI, preloaderI, preloaderII, regulares, icon, string, icon2, metodos, cambio, cuentas, nuCuenta,
            disabled, btnBusq, visibleSwitch, estCent } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let EstIndTable = () => {
            if (regulares === false) {
                if (estDeudores.length === 0) return (
                    <tr align="center">
                        <td colSpan={4} style={styles}><i className={preloaderI.icon}></i> {preloaderI.text}</td>
                    </tr>
                )
    
                return (
                    estDeudores.map (option => (
                        <EstDeudasTable key={option.id} datos={option}
                            metodos = {metodos} cambio = {cambio} cuentas = {cuentas} nuCuenta = {nuCuenta}
                            update = {() => {this.updLista()}}
                        />
                    ))
                )
            }else{
                if (estDeudoresNI.length === 0) return (
                    <tr align="center">
                        <td colSpan={4} style={styles}><i className={preloaderI.icon}></i> {preloaderI.text}</td>
                    </tr>
                )
    
                return (
                    estDeudoresNI.map (option => (
                        <EstDeudasTable key={option.id} datos={option}
                            metodos = {metodos} cambio = {cambio} cuentas = {cuentas} nuCuenta = {nuCuenta}
                            update = {() => {this.updLista()}}
                        />
                    ))
                )
            }
            
        }

        let tablaEst = () => {

            let cantidad = () => {
                if (regulares === false) return estDeudores.length
                return estDeudoresNI.length
            }

            return (
                <React.Fragment>
                    <div className="custom-alert-danger custom-mt-10">
                        <Row>
                            <Col md={5} style={{paddingLeft: 25,}}>
                                <div>{preloaderII.text} <i className={preloaderII.icon}></i></div>
                                <div><strong>Estudantes Encontrados: {cantidad()}</strong></div>
                            </Col>
                            <Col md={7} align="right">
                                <div className = "btn-group" style = {{marginTop: 3}}>
                                    <button className="btn btn-relleno-primary" onClick = {() => {this.busquedaMoroso()}} style={{borderWidth: 1, fontSize: 12}}><i className = {btnBusq.icon}></i> {btnBusq.text}</button>
                                    <button title="Imprimir el listado de los estudiantes con deudas" onClick={() => {
                                        switch(true){
                                            case (preloaderII. icon === "fa fa-arrow-right" && disabled === true):
                                                toast.error("Presiona el botón Iniciar Búsqueda",{autoClose: 4000});
                                            break;
                                            case(disabled === true):
                                                toast.error("Espera que termine de cargar el listado",{autoClose: 4000});
                                            break;
                                            default:
                                                this.setState({openWR: true})
                                            break;
                                        }
                                    }} className="btn btn-relleno-danger" style={{borderWidth: 1, fontSize: 12}}><i className="fa fa-print"></i> Imprimir</button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <div className="table-responsive" id="lisEstDeuda" onScroll={this.update} style={{overflowY: "auto"}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                        <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                        <td width="20%" align="center" style={styles}><strong>Deuda</strong></td>
                                        <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {EstIndTable()}
                                </tbody>
                            </Table>
                            <div align="center"><i className={icon}></i></div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }

        let switchR = () => {
            if (visibleSwitch === false) return null;

            return (
                <React.Fragment>
                    Estudiantes Mostrados
                    <Switch
                        offColor = "#bf4848"
                        onHandleColor = "#fff"
                        onColor = "#4aa6a5"
                        offHandleColor = "#fff"
                        checked = {regulares}
                        onChange = {()=> {this.setState({regulares:!regulares})}} 
                        checkedIcon = { <div style = {{fontSize: 13, minWidth: 120, marginLeft: 26, paddingTop: 9, fontWeight: "bold", color: "#FFF"}}>ACTIVOS</div> }
                        uncheckedIcon = { <div style = {{fontSize: 11, minWidth: 120, marginLeft: -47, paddingTop: 10, color: "#FFF", fontWeight: "bold", fontSize: 12}}>NO INSCRITOS</div> }
                        className = "react-switch" height = {35} width = {140}
                    />
                </React.Fragment>
            )
        }

        let fixInd = (est, percent, respuesta) => {
            let slidePercent = 100 / ((this.state.estCent.length - 1));
            EliminarDec (this.state.estCent[est].id_estudiante, (resp) => {
                this.setState({
                    btn2Fix:{
                        icon: "fa fa-spinner fa-spin",
                        text: `Espera ${Math.round(percent)}%`
                    }
                }, () => {
                    if (est === (this.state.estCent.length - 1)){
                        this.setState({
                            btn2Fix: {
                                text: "Reparar",
                                icon: "fa fa-cog"
                            }
                        }, () => {
                            toast.info(`Se han reparado los decimales con éxito`,{autoClose: 4000});
                        })
                    }
                })

                let estAct = est + 1;
                let perc = percent + slidePercent;
                if (estAct <= (this.state.estCent.length - 1)) fixInd(estAct, perc, (resp) => {})

                respuesta(1)
            })
        }

        let fixEste = () => {
            switch (UserState){
                case "": return null;
                case 0: return null;
                case 1: return (
                    <React.Fragment>
                        <div align="right" /* style = {{display: "none"}} */><button className="btn btn-sm btn-relleno-danger" onClick ={() => {
                            this.setState({
                                btnFix:{
                                    icon: "fa fa-spinner fa-spin",
                                    text: "Espera"
                                }
                            },() => {
                                FixDeuda((resp) => {
                                    this.setState({
                                        btnFix: {
                                            text: "Reparar",
                                            icon: "fa fa-cog"
                                        },
                                    })
                                })
                            })
                        }} style = {{borderWidth: 1, marginTop: 10, display: "none"}}><i className={this.state.btnFix.icon}></i>{this.state.btnFix.text}</button>
                        <button className="btn btn-sm btn-relleno-primary" onClick ={() => {
                            this.setState({
                                btn2Fix:{
                                    icon: "fa fa-spinner fa-spin",
                                    text: `Espera`
                                }
                            },() => {
                                EstDisponibles((resp) =>{
                                    this.setState({
                                        estCent: resp.data
                                    }, () => {
                                        let ni = 0;
                                        if ((resp.data).length > 0) {
                                            fixInd(ni, 0, (resp) => { ni += resp })
                                        }
                                    })
                                })
                            })
                        }} style = {{borderWidth: 1, marginTop: 10, marginLeft: 5}}><i className={this.state.btn2Fix.icon}></i>{this.state.btn2Fix.text}</button>
                        </div>
                        <div style = {{display: "none"}}><textarea className="form-control" value={this.state.estDe} style = {{visibility: "hidden"}}></textarea></div>
                    </React.Fragment>
                )
                default: return null;
            }

            
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md = {8}>
                            Búsqueda de Estudiantes <i className={icon2}></i>
                            <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </Col>
                        <Col md = {4} align = "center">
                            {switchR()}
                        </Col>
                    </Row>
                </div>
                {fixEste()}
                <div>{tablaEst()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">Aqui puedes ver un listado global de los estudiantes que poseen deudas detallando los siguientes datos:</Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Estudiante</strong></Col>
            <Col md={12} align="justify">Nombre y apellido del estudiante</Col>
            
            <Col md={12} className="text-primary custom-mt-10"><strong>Carrera</strong></Col>
            <Col md={12} align="justify">Carrera actual que cursa el estudiante</Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Deuda</strong></Col>
            <Col md={12} align="justify">Es la cantidad expresada en bolívares correspondiente a la deuda actual del estudiante</Col>
        
            <Col md={12} className="text-primary custom-mt-10"><strong>Acciones</strong></Col>
            
            <Col md={12} align="justify">El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button> Muestra las opciones disponibles (Registrar Pago, Ver Estado de Cuenta y Ver Materias Inscritas)</Col> 
            <Col md={12} align="justify">Si deseas buscar un estudiante específico basca con ingresar en el buscador la <strong>Cédula</strong>, <strong>El Nombre</strong> o <strong>El Apellido</strong> del estudiante y presiona la tecla <strong className="text-danger">ENTER</strong></Col>
        </Row>
    )

    modalReporte = () => {
        let { openWR, estDeudores, estDeudoresNI, regulares } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<AlumnosMorosos datos = {estDeudores} datosNi = {estDeudoresNI} reg = {regulares}/>}
                titulo={`Listado de Alumnos Morosos`}
                display= "block"
                cerrar = {() => {this.setState({openWR:false})}}
            />
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Estudiantes con Deudas</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default EstDeudas;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/EstDeudas.jsx